// extracted by mini-css-extract-plugin
module.exports = {"grid":"bB_b2","column":"bB_gv","links":"bB_hm","link":"bB_d","darkMode":"bB_cX"};